import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-navy text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-music-2-line text-3xl text-electric-blue"></i>
              </div>
              <span className="font-display font-bold text-xl">Mixtape Curated</span>
            </div>
            <p className="text-sm text-gray-300 leading-relaxed">
              Premium peptides, fitness regimens, and lifestyle optimization for peak performance.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-base mb-4">Shop</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/peptides" className="text-gray-300 hover:text-electric-blue transition-colors cursor-pointer">Peptides</Link></li>
              <li><Link to="/apparel" className="text-gray-300 hover:text-electric-blue transition-colors cursor-pointer">Apparel</Link></li>
              <li><Link to="/shop" className="text-gray-300 hover:text-electric-blue transition-colors cursor-pointer">Shop Everything</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-base mb-4">Resources</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/fitness" className="text-gray-300 hover:text-electric-blue transition-colors cursor-pointer">Fitness Workouts</Link></li>
              <li><Link to="/playlists" className="text-gray-300 hover:text-electric-blue transition-colors cursor-pointer">Playlists</Link></li>
              <li><Link to="/investment" className="text-gray-300 hover:text-electric-blue transition-colors cursor-pointer">Investments</Link></li>
              <li><Link to="/top-five" className="text-gray-300 hover:text-electric-blue transition-colors cursor-pointer">Today&apos;s Top Five</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-base mb-4">Connect</h4>
            <div className="flex space-x-4 mb-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-lg hover:bg-electric-blue transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-lg hover:bg-electric-blue transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-lg hover:bg-electric-blue transition-colors cursor-pointer">
                <i className="ri-youtube-line text-xl"></i>
              </a>
            </div>
            <Link to="/booking" className="inline-block px-6 py-2 bg-electric-blue text-white rounded-lg text-sm font-medium hover:bg-blue-500 transition-colors whitespace-nowrap cursor-pointer">
              Book Consultation
            </Link>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
          <p>&copy; {currentYear} Mixtape Curated. All rights reserved.</p>
          <div className="flex items-center space-x-4 mt-4 md:mt-0">
            <a href="#" className="hover:text-electric-blue transition-colors cursor-pointer">Privacy Policy</a>
            <span>•</span>
            <a href="#" className="hover:text-electric-blue transition-colors cursor-pointer">Terms of Service</a>
            <span>•</span>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-electric-blue transition-colors cursor-pointer">Powered by Readdy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}